module.exports = __webpack_public_path__ + "img/SuperWA-Logo-3.810b38bb.png";